import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$BuyFeatureControls, BuyFeatureControlsProps} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIBuyFeatureControls/components/BuyFeatureControls';
import {Container} from 'pixi.js';
import {CoreDI, inject, Store} from '@gongxigames/framework/core';
import {BetSelectOnChange} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/components/BetSelect';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {GameConfig} from '@gongxigames/framework/slot';

export class UIBuyFeatureControlsModule extends UIModuleV2 {
    public static NAME = 'UIBuyFeatureControlsModule';
    public static layer = LAYERS.OVER_KEYPAD;

    public container = new Container();
    protected showButtonContainer!: Container;

    @inject(CoreDI.GameConfig)
    protected gameConfig!: GameConfig;

    onInit(): void {
        const uiDefault = $BuyFeatureControls(this.getProps()) as Container;

        this.showButtonContainer = uiDefault.getChildByName('ShowButtonContainer');
        this.container.addChild(uiDefault);
    }

    onSetupEvents(): void {
        // TODO use widgets API in future
        this.emitter.on('Game.command.buyFeature.moveToUi', this.moveToUi.bind(this));
    }

    private moveToUi(container: Container): void {
        this.showButtonContainer.addChild(container);
    }

    private getProps(): BuyFeatureControlsProps {
        const visible = Store.computed(() => slotStore.feature_type.value?.type === 'buyFeaturePopup');
        const positionType = slotStore.stage_isPortrait.value ? 'portrait' : 'landscape';
        const stickTo = this.gameConfig.buyFeatureConfig?.button?.[positionType]?.stickTo ?? 'left';
        const onBetChange: BetSelectOnChange = (action) => {
            action === 'increase' ?
                this.emitter.emit('UI.buyFeature.bet.increase'):
                this.emitter.emit('UI.buyFeature.bet.decrease');
        };

        return {
            betCurrent: slotStore.buyFeature_bet,
            betFormatted: slotStore.buyFeature_betFormatted,
            betList: slotStore.buyFeature_betList,
            visible,
            stickTo,
            onBetChange
        };
    }
}